import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/vendor`;
const LOCATION_GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/location`;

export const vendorService = {
    listVendorSupplyParameter: async function (locationCode:string) {
        return axios.get(`${GATEWAY_URL}/vendors_supply_parameters?locationCode=${locationCode}`)
        .then((response) => {
            return response.data;
        });
    },
    getVendorSupplyParameter: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get_vendors_supply_parameter`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },

    getLocations: async function () {
        return axios.get(`${GATEWAY_URL}/vendors_locations`, {
            
        })
        .then((response) => {
            return response.data;
        });
    },

    getSuppliers: async function () {              
        return axios.get(`${GATEWAY_URL}/vendors_suppliers`, {           
        })
        .then((response) => {
             return response.data;         
        });
    },
    getSupplierCutOffAfterOrder: async function (params: any) {              
        return axios.get(`${GATEWAY_URL}/cut_off_order_after_parameter`, {  params         
        })
        .then((response) => {
             return response.data;         
        });
    },
    createVendorSupplyParameter: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/save_vendors_supply_parameters`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateVendorSupplyParameter: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/save_vendors_supply_parameters`, params)
        .then((response) => {
            return response.data;
        });
    },

    AllLocationLookups: async function () {
        return axios.get(`${LOCATION_GATEWAY_URL}/location_list`)
        .then((response) => {
            return response.data;
        });
    },
    StoreLookups: async function () {
        return axios.get(`${LOCATION_GATEWAY_URL}/location_list?LocationType=1`)
        .then((response) => {
            return response.data;
        });
    },

    SaveVendorSupplyParameters: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_vendors_supply_parameters`, values)
        .then((response) => {
            return response.data;
        });
    },

    
    deleteVendorSupplyParameter: async function (pk:any) {
        return axios.post(`${GATEWAY_URL}/delete_vendors_supply_parameters`, {pk})
            .then((response) => {
                return response.data;
            });
    },

    downloadExcel: async () => {
        try {
            // API çağrısı: Excel dosyasını al
            const response = await axios.get(`${GATEWAY_URL}/excel-file`, {
                responseType: "blob", // Dosya verisi için blob ayarı
                headers: {
                    Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Excel MIME türü
                },
            });
    
            // Blob işlemleri
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "VendorSupplyParameterImport.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Excel dosyası indirilemedi:', error);
        }
    }
}
